import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";

window.$ = window.jQuery = require("jquery");

export default {
    name: "RolPage",
    data() {
        let ss = new MainService();
        return {
            msg: "RolPage",
            ss: ss,
            ajax: {
                "url": ss.indexPermanencia(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Permanencia', name: 'Permanencia', title: 'Permanencia' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
               /*  {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                }, */
            ],
            rols: [],
            rol2:{},
     
            rol: [],
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newRol() {
            this.rol = {};
            this.$refs['frm-rol'].show();
        },
     
        showRol(id) {
          
            this.role_id = id;
            this.isLoading = true;
            this.ss.showRol(id)
              .then((result) => {
                let response = result.data;
                this.rol = response.data[0];
                this.rol2 = response.data[0];
                this.$refs['view-rol'].show();
                this.isLoading = false;
              })
              .catch(error => {
                console.log(error);
                this.isLoading = false;
              });
          },
        editRol() {
            this.$refs['frm-rolEdit'].show();
            this.$refs['view-rol'].hide();
        },
        cancelRol() {
            if (this.rol.role_id) {
                this.$refs['view-rol'].show();
            }
            this.$refs['frm-rol'].hide();
        },
        saveRol() {
            this.ss.storeRol(this.rol).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-rol'].hide();
                    this.$refs['datatable-rol'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        updateRol() {
            try {
                const id = this.role_id;
                console.log("updateRol", id);
        
                this.ss.updateRol({
                    id: id,
                    Rol: this.rol2.Rol,
                    Num: this.rol2.Num,
                })
                .then(result => {
                    console.log(result);
                    let response = result.data;
        
                    this.$bvToast.toast(response.msg, {
                        title: 'Correcto',
                        variant: 'success',
                        autoHideDelay: 5000
                    });
        
                    console.log(response);
                    this.$refs['frm-rolEdit'].hide();
                    this.$refs['datatable-rol'].reload();
                })
                .catch(error => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast('Problema al guardar el registro, favor verificar los datos', {
                        title: 'Error',
                        variant: 'danger',
                        autoHideDelay: 5000
                    });
                });
            } catch (error) {
                console.error('Error in updateRol:', error);
            }
        },
        
        deleteRol(id) {
            
             id = this.role_id; 
            console.log("deleteRol", id);
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible.",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.ss.destroy({ id: id })  
                        .then((result) => {
                            let response = result.data;
                            console.log(response);
                            this.$bvToast.toast(
                                response.msg, // Aquí estás utilizando el mensaje del backend
                                {
                                    title: 'Correcto',
                                    variant: 'success',
                                    autoHideDelay: 5000
                                }
                            )
                            this.$refs['view-rol'].hide();
                            this.$refs['datatable-rol'].reload();
                        })
                        .catch(error => {
                            console.log(error);
                        })
                } else {
                    // No hacer nada si el usuario cancela la eliminación
                }
            });
        },
        
        
        draw() {
            window.$('.btn-datatable-Rol').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showRol(data);
            });
        }
    },
    components: {
        dataTable,
     
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        }else{
            this.auth = persona;
        }
    }
};
